/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const MarginLeftIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Margin Left',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <g>
      <path
        d="M32 32H18V4h14Zm2 1V3a1 1 0 0 0-1-1H17a1 1 0 0 0-1 1v30a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1Z"
      />
      <rect height="10" rx="1" transform="rotate(90 7 18)" width="32" x="-9" y="13" />
    </g>
  </svg>`;
};
